/* eslint-disable */
import React from 'react';
import { Redirect, BrowserRouter as Router, Route, Link, withRouter } from "react-router-dom"
import { Anchor, Carousel, notification } from 'antd';
// import { from } from '_rxjs@6.5.3@rxjs';

// const { Link } = Anchor;
function changeMenu(href) {
    let newHref = href;
    if (href.indexOf('?') > -1) {
        newHref = newHref.slice(0, href.indexOf('?'))
    }
    let nowHref = window.location.hash.split("?")[0];
    if (newHref === '/' + nowHref) {
        window.location.href = href;
        window.location.reload();
    } else {
        window.location.href = href;
    }
}

function unVisible() {
    notification.warning({ message: '该功能暂未开放！' })
}

export const Nav00DataSource = {

    wrapper: { className: 'header0 home-page-wrapper' },
    page: { className: 'home-page' },
    logo: {
        className: 'header0-logo',
        // children: 'https://os.alipayobjects.com/rmsportal/mlcYmsRilwraoAe.svg',
        children: "img/nsec2.png",

    },
    Menu: {
        className: 'header0-menu',
        children: [
            {
                name: 'item0',
                className: 'header0-item',
                children: {
                    href: '/#/',
                    children: [
                        {
                            children: (
                                <>
                                    <p>首页&nbsp;</p>
                                </>
                            ),
                            name: 'text',
                        },
                    ],

                },

            },
            {
                name: 'item1',
                className: 'header0-item',
                children: {
                    href: '/#/productsAndServices',
                    children: [
                        {
                            children: (
                                <>
                                    <p>核心业务&nbsp;</p>
                                </>
                            ),
                            name: 'text',
                        },
                    ],
                },
                subItem: [
                    {
                        className: 'item-sub',
                        children: {
                            className: 'item-sub-item',

                            href: '/#/productsAndServices?key=1',
                            children: [
                                {
                                    name: 'title',
                                    className: 'item-title k0q2z9onh8s-editor_css',
                                    children: (
                                        <>
                                            <p>气象服务及灾害预报预警</p>
                                        </>
                                    ),
                                },
                            ],
                        },
                        name: 'sub~k0q5rfrclk',
                    },
                    {
                        className: 'item-sub',
                        children: {
                            className: 'item-sub-item',
                            href: '/#/productsAndServices?key=2',
                            children: [
                                {
                                    name: 'title',
                                    className: 'item-title k0q2z9onh8s-editor_css',
                                    children: (
                                        <>
                                            <p>环境质量预报预警及辅助决策&nbsp;</p>
                                        </>
                                    ),
                                },
                            ],
                        },
                        name: 'sub~k0q5rfrcld7',
                    },
                    {
                        className: 'item-sub',
                        children: {
                            className: 'item-sub-item',
                            href: '/#/productsAndServices?key=3',
                            children: [
                                {
                                    name: 'title',
                                    className: 'item-title k0q2z9onh8s-editor_css',
                                    children: (
                                        <>
                                            <p>生态环境数据服务及数值模拟应用&nbsp;</p>
                                        </>
                                    ),
                                },
                            ],
                        },
                        name: 'sub~k0q5rfrczet',
                    },
                ],
            },

            {
                name: 'item2',
                className: 'header0-item',
                children: {
                    href: '/#',
                    children: [
                        {
                            children: (
                                <>
                                    <p>环境预报&nbsp;</p>
                                </>
                            ),
                            name: 'text',
                        },
                    ],
                },
                subItem: [
                    {
                        className: 'item-sub',
                        children: {
                            className: 'item-sub-item',
                            children: [
                                {
                                    name: 'title',
                                    className: 'item-title k0q30fxtai-editor_css',
                                    children: (
                                        <>
                                            <p>环境实况&nbsp;</p>
                                        </>
                                    ),
                                },
                            ],
                        },
                        name: 'sub~k0qc6q9fvze',
                    },
                    {
                        className: 'item-sub',
                        children: {
                            className: 'item-sub-item',
                            children: [
                                {
                                    name: 'title',
                                    className: 'item-title k0q30fxtai-editor_css',
                                    href: '/#/talentStrategy',
                                    children: (
                                        <>
                                            <p>环境预报&nbsp;</p>
                                        </>
                                    ),
                                },
                            ],
                        },
                        name: 'sub~k0qc6q9feng',
                    },
                    {
                        className: 'item-sub',
                        children: {
                            className: 'item-sub-item',
                            children: [
                                {
                                    name: 'title',
                                    className: 'item-title k0q30fxtai-editor_css',
                                    children: (
                                        <>
                                            <p>源解析&nbsp;</p>
                                        </>
                                    ),
                                },
                            ],
                        },
                        name: 'sub~k0qc6q9fsbh',
                    },
                    {
                        className: 'item-sub',
                        children: {
                            className: 'item-sub-item',
                            children: [
                                {
                                    name: 'title',
                                    className: 'item-title k0q30fxtai-editor_css',
                                    children: (
                                        <>
                                            <p>模式&nbsp;</p>
                                        </>
                                    ),
                                },
                            ],
                        },
                        name: 'sub~k0qc6q9fk3m',
                    },
                ],
            },
            {
                name: 'item3',
                className: 'header0-item',
                children: {
                    href: '/#/news2',
                    children: [
                        {
                            children: (
                                <>
                                    <p onClick={() => changeMenu('/#/news2')}>新闻资讯&nbsp;</p>
                                </>
                            ),
                            name: 'text',
                        },
                    ],
                },

            },
            {
                name: 'item~k0q2pt8vnth',
                className: 'header0-item',
                children: {
                    href: '/#/talentStrategy',
                    children: [
                        {
                            children: (
                                <>
                                    <p>人才战略</p>
                                </>
                            ),
                            name: 'text',
                        },
                    ],
                },
                subItem: [
                    {
                        className: 'item-sub',
                        children: {
                            className: 'item-sub-item',
                            href: '/#/talentStrategy?key=1',

                            children: [
                                {
                                    name: 'title',
                                    className: 'item-title k0q31k0zaqn-editor_css',
                                    children: (
                                        <>
                                            <p>人才战略&nbsp;</p>
                                        </>
                                    ),
                                },
                            ],
                        },
                        name: 'sub~k0qc8zdyacq',
                    },


                    {
                        className: 'item-sub',
                        children: {
                            className: 'item-sub-item',
                            href: '/#/talentStrategy?key=2',

                            children: [
                                {
                                    name: 'title',
                                    className: 'item-title k0q31k0zaqn-editor_css',
                                    children: (
                                        <>
                                            <p>职位信息&nbsp;</p>
                                        </>
                                    ),
                                },
                            ],
                        },
                        name: 'sub~k0qc8zdyhd8',
                    },
                ],
            },
            {
                name: 'item~k0q2rwewxg9',
                className: 'header0-item',
                children: {
                    href: '#',
                    children: [
                        {
                            children: (
                                <>
                                    <p>关于我们</p>
                                </>
                            ),
                            name: 'text',
                        },
                    ],
                },
                subItem: [
                    {
                        className: 'item-sub',
                        children: {
                            className: 'item-sub-item',
                            href: '/#/aboutUs?key=1',

                            children: [
                                {
                                    name: 'title',
                                    className: 'item-title k0q31z92zs-editor_css',
                                    children: '公司简介',
                                },
                            ],
                        },
                        name: 'sub~k0q32q26upj',
                    },
                    // {
                    //     className: 'item-sub',
                    //     children: {
                    //         className: 'item-sub-item',
                    //         href: '/#/aboutUs',

                    //         children: [
                    //             {
                    //                 name: 'title',
                    //                 className: 'item-title k0q31z92zs-editor_css',
                    //                 children: '公司理念',
                    //             },
                    //         ],
                    //     },
                    //     name: 'sub~k0q32q26of',
                    // },
                    {
                        className: 'item-sub',
                        children: {
                            className: 'item-sub-item',
                            href: '/#/aboutUs?key=2',

                            children: [
                                {
                                    name: 'title',
                                    className: 'item-title k0q31z92zs-editor_css',
                                    children: '团队实力',
                                },
                            ],
                        },
                        name: 'sub~k0q32q263p',
                    },
                    {
                        className: 'item-sub',
                        children: {
                            className: 'item-sub-item',
                            href: '/#/aboutUs?key=3',

                            children: [
                                {
                                    name: 'title',
                                    className: 'item-title k0q31z92zs-editor_css',
                                    children: '服务优势',
                                },
                            ],
                        },
                        name: 'sub~k0q32q26fnu',
                    },

                    // {
                    //     className: 'item-sub',
                    //     children: {
                    //         className: 'item-sub-item',
                    //         href: '/#/aboutUs?key=4',

                    //         children: [
                    //             {
                    //                 name: 'title',
                    //                 className: 'item-title k0q31z92zs-editor_css',
                    //                 children: '团队介绍',
                    //             },
                    //         ],
                    //     },
                    //     name: 'sub~k0q32q263p',
                    // },
                    {
                        className: 'item-sub',
                        children: {
                            className: 'item-sub-item',
                            href: '/#/aboutUs?key=4',

                            children: [
                                {
                                    name: 'title',
                                    className: 'item-title k0q31z92zs-editor_css',
                                    children: '资质荣誉',
                                },
                            ],
                        },
                        name: 'sub~k0q32q26u08',
                    },
                ],
            },
            {
                name: 'item~k0q2ry7rc7t',
                className: 'header0-item',
                children: {
                    href: '/#/contactUs',
                    children: [
                        {
                            children: (
                                <>
                                    <p>联系我们</p>
                                </>
                            ),
                            name: 'text',
                        },
                    ],
                },
            },
        ],
    },
    mobileMenu: { className: 'header0-mobile-menu' },
};

export const Banner10DataSource = {
    wrapper: { className: 'banner1' },
    BannerAnim: {
        children: [
            {
                name: 'elem0',
                BannerElement: { className: 'banner-user-elem' },
                textWrapper: {
                    className: 'banner1-text-wrapper k0q4hb9hj6-editor_css',
                },
                bg: { className: 'bg bg0' },//k0q595j1hto-editor_css
                title: {
                    className: 'banner1-title k0q26js4s47-editor_css',
                    children: (
                        <>
                            <img src={'/img/headline1.png'} style={{ width: '100%' }} />
                        </>
                    ),
                },
                content: {
                    className: 'banner1-content k0q4hah51nh-editor_css',
                    children: (
                        <>

                        </>
                    ),
                },
                button: {
                    className: 'banner1-button ant-btn k0q24np4nwm-editor_css',
                    children: (
                        <>
                            <p>
                                <br />
                            </p>
                        </>
                    ),
                },
            },
            {
                name: 'elem~k0q4tyxxsm',
                BannerElement: { className: 'banner-user-elem' },
                textWrapper: {
                    className: 'banner1-text-wrapper k0q4hb9hj6-editor_css',
                },
                bg: { className: 'bg bg1' },
                title: {
                    className: 'banner1-title k0q26js4s47-editor_css',
                    children: (
                        <>
                            <img src={'/img/headline2.png'} style={{ width: '90%' }} />
                        </>
                    ),
                },
                content: {
                    className: 'banner1-content k0q4hah51nh-editor_css',
                    children: (
                        <>

                        </>
                    ),
                },
                button: {
                    className: 'banner1-button ant-btn k0q24np4nwm-editor_css',
                    children: (
                        <>
                            <p>
                                <br />
                            </p>
                        </>
                    ),
                },
            },
            {
                name: 'elem~k0q4tzr6wjc',
                BannerElement: { className: 'banner-user-elem' },
                textWrapper: {
                    className: 'banner1-text-wrapper k0q4hb9hj6-editor_css',
                },
                bg: { className: 'bg bg2' },// k0q595j1hto-editor_css
                title: {
                    className: 'banner1-title k0q26js4s47-editor_css',
                    children: (
                        <>
                            <img src={'/img/headline3.png'} style={{ width: '80%' }} />

                        </>
                    ),
                },
                content: {
                    className: 'banner1-content k0q4hah51nh-editor_css',
                    children: (
                        <>
                            <p></p>
                        </>
                    ),
                },
                button: {
                    className: 'banner1-button ant-btn k0q24np4nwm-editor_css',
                    children: (
                        <>
                            <p>
                                <br />
                            </p>
                        </>
                    ),
                },
            },
        ],
    },
};

export const Content51DataSource = {
    wrapper: { className: 'home-page-wrapper content5-wrapper' },
    page: { className: 'home-page content5' },
    OverPack: { playScale: 0.3, className: '' },
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            {
                name: 'title',
                children: (
                    <>
                        <p>新闻资讯&nbsp;</p>
                    </>
                ),
                className: 'title-h1',
            },
        ],
    },
    block: {
        className: 'content5-img-wrapper',
        gutter: 16,
        children: [
            {
                name: 'block0',
                className: 'block',
                md: 6,
                xs: 24,
                children: {
                    wrapper: { className: 'content5-block-content' },
                    img: {
                        children: 'https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg',
                    },
                    content: { children: 'Ant Design' },
                },
            },
            {
                name: 'block1',
                className: 'block',
                md: 6,
                xs: 24,
                children: {
                    wrapper: { className: 'content5-block-content' },
                    img: {
                        children: 'https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg',
                    },
                    content: { children: 'Ant Motion' },
                },
            },
            {
                name: 'block2',
                className: 'block',
                md: 6,
                xs: 24,
                children: {
                    wrapper: { className: 'content5-block-content' },
                    img: {
                        children: 'https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg',
                    },
                    content: { children: 'Ant Design' },
                },
            },
            {
                name: 'block3',
                className: 'block',
                md: 6,
                xs: 24,
                children: {
                    wrapper: { className: 'content5-block-content' },
                    img: {
                        children: 'https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg',
                    },
                    content: { children: 'Ant Motion' },
                },
            },
        ],
    },
};

export const Teams10DataSource = {
    wrapper: { className: 'home-page-wrapper teams1-wrapper' },
    page: { className: 'home-page teams1' },
    OverPack: { playScale: 0.3, className: '' },
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            {
                name: 'title',
                children: (
                    <>
                        <p>核心业务&nbsp;</p>
                    </>
                ),
            },
        ],
    },
    block: {
        className: 'block-wrapper',
        children: [
            {
                name: 'block0',
                className: 'block',
                md: 6,
                xs: 24,
                titleWrapper: {
                    children: [
                        {
                            name: 'image',
                            className: 'teams1-image',
                            children: 'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                        },
                        { name: 'title', className: 'teams1-title', children: '叶秀英' },
                    ],
                },
            },
            {
                name: 'block1',
                className: 'block',
                md: 6,
                xs: 24,
                titleWrapper: {
                    children: [
                        {
                            name: 'image',
                            className: 'teams1-image',
                            children: 'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*njqxS5Ky7CQAAAAAAAAAAABjARQnAQ',
                        },
                        { name: 'title', className: 'teams1-title', children: '韩勇' },
                    ],
                },
            },
            {
                name: 'block2',
                className: 'block',
                md: 6,
                xs: 24,
                titleWrapper: {
                    children: [
                        {
                            name: 'image',
                            className: 'teams1-image',
                            children: 'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                        },
                        { name: 'title', className: 'teams1-title', children: '叶秀英' },
                    ],
                },
            },
            {
                name: 'block~k0q3r034z1i',
                className: 'block',
                md: 6,
                xs: 24,
                titleWrapper: {
                    children: [
                        {
                            name: 'image',
                            className: 'teams1-image',
                            children: 'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                        },
                        { name: 'title', className: 'teams1-title', children: '叶秀英' },
                    ],
                },
            },
        ],
    },
};

export const Content130DataSource = {
    OverPack: {
        className: 'home-page-wrapper content13-wrapper',
        playScale: 0.3,
    },
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            /*  {
             name: 'image',
             children:
             'https://gw.alipayobjects.com/zos/rmsportal/PiqyziYmvbgAudYfhuBr.svg',
             className: 'title-image',
             },*/
            {
                name: 'title',
                children: (
                    <>
                        <p>business</p>
                        <p>走进雨后</p>
                    </>
                ),

                className: 'title-h1'
            },
            {
                name: 'content',
                children: (
                    <div>
                        <p style={{ fontWeight: "800", fontSize: "16px" }}>
                            使命/愿景（Mission & Vision） —— 创新 引领 启未来
                        </p>
                        <p>
                            创新、引领气象、环境、生态等相关领域的预测、模拟与决策服务技术，为环境污染防治和生态保护提供技术支持与决策服务，以可持续发展理念实现社会价值、客户价值、股东价值、员工价值，共创美好未来！
                        </p>
                        <p style={{ fontWeight: "800", fontSize: "16px" }}>
                            价值观
                        </p>
                        <p>
                            至诚至善，合作共赢
                        </p>
                        <p style={{ fontWeight: "800", fontSize: "16px" }}>
                            服务理念
                        </p>
                        <p>
                            用诚信携手客户同行
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            用实力博取大业价值
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            用胸怀勾画天地大美</p>
                    </div>
                ),

                className: 'title-content',
            },
        ],
    },
};
export const Banner31DataSource = {
    wrapper: { className: 'Home_banner3' },
    textWrapper: {
        className: 'Home_banner3-text-wrapper',
        children: [
            {
                name: 'slogan',
                className: 'Home_banner3-slogan k0q3w8qt66r-editor_css',
                children: '南京雨后地软环境技术有限公司',
                texty: true,
            },
            {
                name: 'name',
                className: 'Home_banner3-name k0q3wqyztke-editor_css',
                children: (
                    <>
                        <p>
                            南京雨后地软环境技术有限公司是一家专业从事大气科学、环境科学、生态学等相关学科研究、应用及咨询的高新技术企业，是气象、环境和生态行业领域数据分析、数值模拟及预报预警方面的系统解决方案专家。
                        </p>
                    </>
                ),
            },
        ],
    },
};

export const Footer10DataSource = {
    wrapper: {
        className: 'home-page-wrapper footer1-wrapper k0q3glfva9-editor_css',
    },
    OverPack: { className: 'footer1', playScale: 0.2 },
    block: {
        className: 'home-page k0q3dbydva-editor_css',
        gutter: 0,
        children: [
            {
                name: 'block0',
                xs: 24,
                md: 6,
                className: 'block k0q3bqxiwoe-editor_css',
                title: {
                    className: 'logo',
                    children: "img/nsec.png",
                },
                childWrapper: {
                    className: 'slogan',
                    children: [
                        {
                            name: 'content0',
                            children: (
                                <>
                                    <p>地址：&nbsp;江苏省南京市鼓楼区古平岗4号智梦园C座412</p>
                                </>
                            ),
                        },
                        {
                            name: 'content~k0q3l1uesqc',
                            className: '',
                            children: (
                                <>
                                    <p>电话： 025-89670505</p>
                                </>
                            ),
                        },
                        {
                            name: 'content~k0q3l431eka',
                            className: '',
                            children: (
                                <>
                                    <p>邮箱： yhdr@njyhdr.com</p>
                                </>
                            ),
                        },
                        {
                            name: 'content~k0q3l6hhi9i',
                            className: '',
                            children: (
                                <>
                                    <p>网址：&nbsp;www.njyhdr.com</p>
                                </>
                            ),
                        },
                    ],
                },
            },
            {
                name: 'block~k0q3e97q2',
                xs: 24,
                md: 3,
                className: 'block',
                title: {
                    children: (
                        <>
                            <a
                                href={"/#/productsAndServices"}
                                style={{ color: "#ccc" }}>核心业务</a>
                        </>
                    ),
                },
                childWrapper: {
                    className: "tall",
                    children: [
                        {
                            name: 'link0',
                            href: '/#/productsAndServices?key=1',
                            children: <>
                                <a //href={"/#/productsAndServices?key=1"}
                                    style={{ lineHeight: "25px" }}
                                    onClick={() => changeMenu('/#/productsAndServices?key=1')}
                                >气象服务及灾害预报预警</a>
                            </>
                        },
                        {
                            name: 'link1',
                            href: '/#/productsAndServices?key=2',
                            children: <><a style={{ lineHeight: 0 }}
                                onClick={() => changeMenu('/#/productsAndServices?key=2')}
                            >环境质量预报预警及辅助决策</a></>
                        },
                        {
                            name: 'link2',
                            href: '/#/productsAndServices?key=3',
                            children: <><a style={{ lineHeight: 0 }}
                                onClick={() => changeMenu('/#/productsAndServices?key=3')}
                            >生态环境数据服务及数值模拟应用</a></>
                        },
                    ],
                },
            },
            {
                name: 'block~k0q3ec1kmf',
                xs: 24,
                md: 3,
                className: 'block',
                title: {
                    children: (
                        <>
                            <a //href={"#"}
                                style={{ color: "#ccc" }}>
                                环境预报&nbsp;
                            </a>
                        </>
                    ),
                },
                childWrapper: {
                    children: [
                        {
                            name: 'link0',
                            href: '#',
                            children: <><a onClick={() => unVisible()}
                            >实况&nbsp;</a></>
                        },
                        {
                            name: 'link1',
                            href: '#',
                            children: <><a //href="#"
                                onClick={() => unVisible()}
                            >预报&nbsp;</a></>
                        },
                        {
                            name: 'link2',
                            href: '#',
                            children: <><a //href="#"
                                onClick={() => unVisible()}
                            >源解析&nbsp;</a></>
                        },
                        {
                            name: 'link3',
                            href: '#',
                            children: <><a //href="#"
                                onClick={() => unVisible()}
                            >模式&nbsp;</a></>
                        },
                    ],
                },
            },
            {
                name: 'block~k0q3edaesve',
                xs: 24,
                md: 3,
                className: 'block',
                title: {
                    children: (
                        <>
                            <a //href={"/#/news2"}
                                onClick={() => changeMenu('/#/news2', '新闻资讯')}
                                style={{ color: "#ccc" }}>新闻资讯&nbsp;</a>
                            {/*<p>新闻资讯&nbsp;</p>*/}
                        </>
                    ),
                },
                childWrapper: {
                    children: [],
                },
            },
            {
                name: 'block~k0q3eeiuml6',
                xs: 24,
                md: 3,
                className: 'block',
                title: {
                    children: (
                        <>
                            <a onClick={() => changeMenu('/#/talentStrategy')}
                                //href={"/#/talentStrategy"}
                                style={{ color: "#ccc" }}>人才战略&nbsp;</a>
                            {/*<p>招贤纳士&nbsp;</p>*/}
                        </>
                    ),

                },
                childWrapper: {
                    children: [
                        {
                            name: "link0",
                            href: '/talentStrategy',
                            children: (<><a
                                //href={"/#/talentStrategy"}
                                onClick={() => changeMenu('/#/talentStrategy?key=1')}
                            >人才战略&nbsp;</a></>),
                        },
                        {
                            name: 'link2',
                            href: '/#/talentStrategy',
                            children: (<><a
                                onClick={() => changeMenu('/#/talentStrategy?key=2')}
                            //  href={"/#/talentStrategy"}
                            >职位信息&nbsp;</a></>)
                        }

                    ],
                },
            },
            {
                name: 'block~k0q3egslz8',
                xs: 24,
                md: 3,
                className: 'block',
                title: {
                    children: (
                        <>
                            {/*<p>关于我们&nbsp;</p>*/}
                            <a //href={"/#/aboutUs"}
                                onClick={() => changeMenu('/#/aboutUs', '关于我们')}
                                style={{ color: "#ccc" }}>关于我们&nbsp;</a>
                        </>
                    ),
                },
                childWrapper: {
                    children: [
                        {
                            name: 'link0',
                            href: '/aboutUs?key=1',
                            children: (<><a onClick={() => changeMenu('/#/aboutUs?key=1')}
                            //href={"/#/aboutUs"}
                            >公司简介&nbsp;</a></>),
                        },

                        {
                            name: 'link3',
                            href: '/#/aboutUs?key=3',
                            children: (<><a onClick={() => changeMenu('/#/aboutUs?key=2')}>服务优势&nbsp;</a></>)
                        },
                        {
                            name: 'link3',
                            href: '/#/aboutUs?key=4',
                            children: (<><a onClick={() => changeMenu('/#/aboutUs?key=3')}>团队介绍&nbsp;</a></>)
                        },
                        {
                            name: 'link3',
                            href: '/#/aboutUs?key=5',
                            children: (<><a onClick={() => changeMenu('/#/aboutUs?key=4')}>资质荣誉&nbsp;</a></>)
                        },
                    ],
                },
            },
            {
                name: 'block~k1q3egslz9',
                xs: 24,
                md: 3,
                className: 'block',
                title: {
                    children: (
                        <>
                            {/*<p>关于我们&nbsp;</p>*/}
                            <a href={"/#/aboutUs"} style={{ color: "#ccc" }}>快捷链接&nbsp;</a>
                        </>
                    ),
                },
                childWrapper: {
                    children: [
                        {
                            name: 'link0',
                            href: '/#/aboutUs',
                            children: (<><a href={"http://221.226.156.94:18090/public/index.html"}>月度考核&nbsp;</a></>),
                        },
                        {
                            name: 'link2', href: '/#/aboutUs', children: (<>
                                <a href={"http://webmail.njyhdr.com/page/login/login.jsp"}>公司邮箱&nbsp;</a>
                            </>)
                        },
                    ],
                },
            }
        ],
    },
    copyrightWrapper: { className: 'copyright-wrapper' },
    copyrightPage: { className: 'home-page' },
    copyright: {
        className: 'copyright',
        children: (
            <>
                <span style={{ marginRight: 20 }}>©南京雨后地软环境技术有限公司版权所有</span>
                <a onClick={() => window.open("https://beian.miit.gov.cn/#/Integrated/recordQuery")}>苏ICP备17053780号-1</a>
            </>
        ),
    },
};

